import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const token = sessionStorage.getItem('token');
  const currentUrl = state.url;

  if (currentUrl.startsWith('/login')) {
    if (token) {
      const returnUrl = route.queryParams['returnUrl'] || '/bank-detail';
      return router.createUrlTree([returnUrl]);
    }
    return true;
  }

  if (token) {
    return true;
  }

  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: currentUrl },
  });
};